export class CalcDosageModel {
    intCodeNo: number
    sglDosage: number
    lngPetNo: number
    sglVar: number
    sglMinDose: number
    sglMaxDose: number
    intClinicNo: number
    CalcDose: number
    sglQty: number
    QtyUnit: string 
    constructor(
        intCodeNo: number,
        sglDosage: number,
        lngPetNo: number,
        sglVar: number,
        sglMinDose: number,
        sglMaxDose: number,
        intClinicNo: number,
        CalcDose: number,
        sglQty: number,
        QtyUnit: string 
    ) {
        this.intCodeNo = intCodeNo
        this.sglDosage = sglDosage
        this.lngPetNo = lngPetNo
        this.sglVar = sglVar
        this.sglMinDose = sglMinDose
        this.sglMaxDose = sglMaxDose
        this.intClinicNo = intClinicNo
        this.sglQty = sglQty
        this.CalcDose = CalcDose
        this.QtyUnit = QtyUnit
    }
}